import type { Document } from '@contentful/rich-text-types';
import { useTracking } from 'react-tracking';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Row } from '@simplywallst/ui-core';
import {
  AuthorWrapper,
  Avatar,
  AuthorBioSection,
  ProfileLink,
  AuthorName,
} from './styled';

// TODO: A lot of this typing needs a refactor as its overly complicated and could be narrowed further up
type UnknownBio = Record<string, unknown> | null | unknown[];
type BioWithContent = { content: unknown[] };

type Props = {
  name: string;
  slug: string;
  photoURL: string | null;
  bio: UnknownBio;
};

const isBioWithContent = (bio: UnknownBio): bio is BioWithContent => {
  if (!bio) {
    return false;
  }
  return bio && 'content' in bio;
};

export const AuthorWidget = ({ name, slug, photoURL, bio }: Props) => {
  const { trackEvent } = useTracking();
  const firstParagraph = isBioWithContent(bio) && bio.content[0]; // Only show the first paragraph from author bio
  return (
    <AuthorWrapper>
      <Row alignItem="center">
        {photoURL && <Avatar src={photoURL} alt={name} />}
        <AuthorName>{name}</AuthorName>
      </Row>
      {firstParagraph ? (
        <Row>
          <AuthorBioSection>
            {documentToReactComponents(firstParagraph as Document)}
          </AuthorBioSection>
        </Row>
      ) : null}
      <Row>
        <ProfileLink
          href={`https://simplywall.st/news/about-simply-wall-st-news/${slug}`}
          target="_blank"
          onClick={() => {
            trackEvent({
              type: 'track',
              subject: 'author_sidebar',
              action: 'click',
              slug: slug,
            });
          }}
        >
          View Profile
        </ProfileLink>
      </Row>
    </AuthorWrapper>
  );
};
